import { useCallback, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { refreshCurrentSession } from '../../stores/actions/access';
import { UNATHOURIZED } from '../../stores/reducers/authorizationGuard/sessionStatus';
import { AuthService } from 'src/services';

const authService = new AuthService();

function AuthorizationGuard(props) {
  const { dispatch, sessionStatus, running, needSignDocuments } = props;
  const [refreshed, setRefreshed] = useState(false);

  // logout
  const logoutCallback = useCallback(() => {
    const callback = () => window.location.reload();

    if (authService.isAuthenticated()) {
      authService.removeToken(callback);
    } else {
      callback();
    }
  }, [dispatch]);

  useEffect(() => {
    if (!refreshed && !running) {
      // get current session
      refreshCurrentSession(dispatch);
      // set like refreshed screen
      setRefreshed(true);
    }
  }, [dispatch, refreshed, running]);

  // se o sessionStatus é UNATHOURIZED faz logout automático.
  // Com LGPD pendente o 401/403 é esperado até a assinatura, então não desloga.
  useEffect(() => {
    if ((refreshed && !running) && sessionStatus === UNATHOURIZED && !needSignDocuments) {
      logoutCallback();
    }
  }, [sessionStatus, logoutCallback, refreshed, running, needSignDocuments]);

  return null;
}

const mapStateToProps = (state) => {
  const { authorizationGuard, access } = state;
  return { ...authorizationGuard, needSignDocuments: access.needSignDocuments };
};

export default connect(mapStateToProps)(AuthorizationGuard);
